<template>
    <div class="mainlayout">
        <div class="listchat-contain">
            <ListChat ref="listchatref" @removechat="setallnull" @bukachat="setActiveChat"
                :currentTiketState="currentstate" />
        </div>
        <div class="chatactive-contain">
            <ContainerView ref="containerchatref" :chatactive="activechat" @closethisticket="closetiketparent"
                @updatepesanerror="updatepesanerror" @tandai="tandaiChat" @updatedata="updatedata"
                :currentTiketState="currentstate" />
        </div>
    </div>
</template>
<script>
import ContainerView from "@/components/agent/inbox/container/ContainerView.vue";
import ListChat from "../../components/agent/inbox/listchat/ListChat.vue";

export default {
    name: "InboxLayout",
    data() {
        return {
            activechat: null,
            activechat2: null,
            currentstate: {
                idtiket: null,
                no_tiket: null,
                username: null,
                namaperusahaan: null,
                socketio: null
            },
        };
    },
    props: {},
    components: { ListChat, ContainerView },
    mounted() { },
    computed: {},
    methods: {
        setActiveChat(item) {
            this.activechat = item.clone();
            this.currentstate = {
                idtiket: this.activechat.id,
                no_tiket: this.activechat.no_tiket,
                username: this.activechat.perusahaan.username,
                namaperusahaan: this.activechat.perusahaan.nama_perusahaan
            }
            this.$nextTick(() => {
                this.$refs.containerchatref?.scrollBottom();
            });
        },

        tandaiChat() {
            this.activechat.ditandai = !this.activechat.ditandai
            this.$refs.listchatref
                .updatetandai(this.activechat)
        },

        updatedata(params) {
            //update data from container
            this.$refs.listchatref?.addnewmessage({
                ...params
            }, true)

            return params
        },

        updatepesanerror(params) {
            this.activechat.messages.map((e) => {
                if (e?.kodeunik == params.kodeunik) {
                    e['senderror'] = true
                }
            })
            this.$refs.listchatref?.updatepesanerror(
                params.notiket, params.kodeunik
            )
        },

        closetiketparent(idtiket, no_tiket) {
            this.$refs.listchatref?.closetiket(idtiket, no_tiket)
        },

        setallnull(notiket) {
            if (notiket == this.currentstate.no_tiket) {
                this.activechat = null
                this.currentstate = {
                    idtiket: null,
                    no_tiket: null,
                    username: null,
                    namaperusahaan: null
                }
            }
        }

    },
};

</script>
<style scoped>
.mainlayout {
    height: 100vh;
    width: 100%;
    display: grid;
    overflow: hidden;
    grid-template-columns: max-content auto;
}

.listchat-contain {
    height: 100vh;
    overflow: auto;
    width: max-content;
}
</style>
